export enum ControlTypes {
  Checkbox = 'checkbox',
  Dropdown = 'dropdown',
  Textbox = 'textbox',
  Date = 'datebox',
  Time = 'timebox'
}
